"use strict";
module.exports = {
    entityModel: 'supplierSalesReport',
    events: {
        SUPPLIER_SALES_REPORT_CREATED: 'SUPPLIER_SALES_REPORT_CREATED',
        SUPPLIER_SALES_REPORT_UPDATED: 'SUPPLIER_SALES_REPORT_UPDATED',
        SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER: 'SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER',
    },
    actions: {
        get: 'v1.supplierSalesReport.get',
        list: 'v1.supplierSalesReport.list',
        setOwningSupplierOrganization: 'v1.supplierSalesReport.setOwningSupplierOrganization',
        upsert: 'v1.supplierSalesReport.upsert',
        upsertWhenEmpty: 'v1.supplierSalesReport.upsertWhenEmpty',
        updateWhenEmpty: 'v1.supplierSalesReport.updateWhenEmpty',
        update: 'v1.supplierSalesReport.update',
    },
    reportStates: {
        created: 'created',
        sentToSupplier: 'sentToSupplier',
        invoiceRecievedFromSupplier: 'invoiceRecievedFromSupplier',
        invoiceCompleted: 'invoiceCompleted',
    },
    serviceAgreements: {
        'v2.5': 'v2.5',
        v3: 'v3',
    },
    supplierSalesReportRows: {
        sections: {
            sales: 'sales',
            systembolaget: 'systembolaget',
            adjustments: 'adjustments',
        },
    },
};
